import { Nullable } from '@/shared/types/app.types'

export interface LocalTargetResponseTimeComboParsing {
    id: number
    description: string
}

export interface LocalTargetResponseTimeModalComboElement {
    id: number
    text: string
}

export interface LocalTargetResponseTimeModalCombo {
    list: LocalTargetResponseTimeModalComboElement[]
    selected: Nullable<LocalTargetResponseTimeModalComboElement>
}

export interface LocalTargetResponseTimeModalState {
    id: Nullable<number>
    daysToDiagnosticTargetResponseDate: number
    daysToGlobalTargetResponseDate: number
    daysToRegisterTargetResponseDate: number
    daysToSampleGrossingDelay: number
    sampleTypes: LocalTargetResponseTimeModalCombo
    topographicCodes: LocalTargetResponseTimeModalCombo
    procedures: LocalTargetResponseTimeModalCombo
    mostLikelyMorphologicCodes: LocalTargetResponseTimeModalCombo
    priorities: LocalTargetResponseTimeModalCombo
    centers: LocalTargetResponseTimeModalCombo
    departments: LocalTargetResponseTimeModalCombo
}
export const initialLocalTargetResponseTimeModalState =
    (): LocalTargetResponseTimeModalState => ({
        id: null,
        daysToDiagnosticTargetResponseDate: 0,
        daysToGlobalTargetResponseDate: 0,
        daysToRegisterTargetResponseDate: 0,
        daysToSampleGrossingDelay: 0,
        sampleTypes: {
            list: [],
            selected: null
        },
        topographicCodes: {
            list: [],
            selected: null
        },
        procedures: {
            list: [],
            selected: null
        },
        mostLikelyMorphologicCodes: {
            list: [],
            selected: null
        },
        priorities: {
            list: [],
            selected: null
        },
        centers: {
            list: [],
            selected: null
        },
        departments: {
            list: [],
            selected: null
        }
    })
